import type {
  CreateMediaRequest,
  GetAllMediaResponse,
  MediaGetResponse,
  PatientMediaCreateRequest,
} from '@quromedical/models';
import { trpcClient } from 'trpc';

export interface Params {
  count?: number;
  pageToken?: string;
  subject: string;
  operator?: string;
  device?: string;
}

export class MediaApi {
  getMedia = async (id: string): Promise<MediaGetResponse> =>
    await trpcClient.media.getById.query({ id });

  createMedia = async (
    patientId: string,
    data: CreateMediaRequest,
  ): Promise<MediaGetResponse[]> => {
    const media: PatientMediaCreateRequest = {
      media: data.media,
      patient: patientId,
    };

    return await trpcClient.media.create.mutate(media);
  };

  getAllMedia = async (params: Params): Promise<GetAllMediaResponse> =>
    await trpcClient.media.getAll.query(params);

  updateMedia = async (params: MediaGetResponse): Promise<MediaGetResponse> =>
    await trpcClient.media.update.mutate(params);
}
